/*
  cart-drawer-gift-wrap-CUSTOM.js
  Obsluga modulu "Pakowanie na prezent" w cart drawerze.

  Uzywa event delegation na document, dzieki czemu dziala
  nawet po podmianie innerHTML drawera (refresh sekcji).

  Ladowane raz przez script_tag w cart-drawer-CUSTOM.liquid.
*/
(function () {
  'use strict';

  /* Guard: chronimy przed wielokrotna inicjalizacja */
  if (window.__swGiftwrapInit) return;
  window.__swGiftwrapInit = true;

  /* --- POMOCNICZE --- */
  function getRoot() {
    return document.querySelector('[data-sw-giftwrap]');
  }

  function showError(msg) {
    const root = getRoot();
    if (!root) return;
    const errBox = root.querySelector('[data-sw-giftwrap-error]');
    if (!errBox) return;
    errBox.textContent = msg;
    errBox.hidden = false;
  }

  function hideError() {
    const root = getRoot();
    if (!root) return;
    const errBox = root.querySelector('[data-sw-giftwrap-error]');
    if (!errBox) return;
    errBox.hidden = true;
    errBox.textContent = '';
  }

  /* --- ODSWIEZANIE DRAWERA ---
     Pobiera HTML sekcji 'cart-drawer' i podmienia .side-panel-inner.
     Drawer zostaje otwarty, tylko zawartosc sie zmienia. */
  function refreshDrawer() {
    fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const html = data['cart-drawer'];
        if (!html) {
          window.location.reload();
          return;
        }
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newInner = parsed.querySelector('cart-drawer .side-panel-inner');
        const currentInner = document.querySelector('cart-drawer .side-panel-inner');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); });
  }

  /* --- TEKSTY (z data-attrs na rootcie) --- */
  function getMsg(key, fallback) {
    const root = getRoot();
    if (!root) return fallback;
    const val = root.getAttribute('data-msg-' + key);
    return val || fallback;
  }

  /* --- DODAJ PACZKE --- */
  function handleAdd(btn) {
    hideError();
    btn.classList.add('is-loading');
    btn.disabled = true;

    const root = getRoot();
    const textarea = root ? root.querySelector('[data-sw-giftwrap-dedication]') : null;
    const variantId = parseInt(btn.dataset.variantId, 10);
    const dedication = textarea ? textarea.value.trim() : '';
    const packId = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    const dedicationLabel = root ? (root.getAttribute('data-dedication-key') || 'Dedykacja') : 'Dedykacja';

    const properties = { '_paczka_id': packId };
    if (dedication) {
      properties[dedicationLabel] = dedication;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: properties }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) {
          showError(res.description || res.message || getMsg('error', 'Blad'));
          btn.classList.remove('is-loading');
          btn.disabled = false;
          return;
        }
        refreshDrawer();
      })
      .catch(function (err) {
        console.error('Gift wrap add error', err);
        showError(getMsg('error', 'Nie udalo sie dodac paczki. Sprobuj ponownie.'));
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  /* --- USUN POJEDYNCZA PACZKE --- */
  function handlePackRemove(btn) {
    hideError();
    btn.disabled = true;
    btn.classList.add('is-loading');

    const lineKey = btn.dataset.lineKey;
    const lineQty = parseInt(btn.dataset.lineQuantity, 10) || 1;
    const newQty = lineQty > 1 ? lineQty - 1 : 0;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshDrawer(); })
      .catch(function (err) {
        console.error('Gift wrap pack remove error', err);
        showError(getMsg('error', 'Nie udalo sie usunac paczki.'));
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  /* --- USUN WSZYSTKIE PACZKI --- */
  function handleRemoveAll(btn) {
    const confirmMsg = getMsg('confirm-remove-all', 'Usunac wszystkie paczki prezentowe?');
    if (!confirm(confirmMsg)) return;

    hideError();
    btn.disabled = true;
    btn.classList.add('is-loading');

    const root = getRoot();
    if (!root) return;

    const removeBtns = root.querySelectorAll('[data-sw-giftwrap-pack-remove]');
    const lineKeys = Array.from(removeBtns).map(function (b) { return b.dataset.lineKey; });
    const uniqueKeys = lineKeys.filter(function (k, i) { return lineKeys.indexOf(k) === i; });

    uniqueKeys.reduce(function (chain, key) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      });
    }, Promise.resolve())
      .then(function () { refreshDrawer(); })
      .catch(function (err) {
        console.error('Gift wrap remove all error', err);
        showError(getMsg('error', 'Nie udalo sie usunac paczek.'));
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  /* --- TOGGLE CHECKBOX (rozwijanie/zwijanie) --- */
  function handleToggleChange(toggle) {
    const root = getRoot();
    if (!root) return;
    const packsCount = parseInt(root.dataset.packsCount, 10) || 0;
    const hasPacks = packsCount > 0;

    if (hasPacks && !toggle.checked) {
      /* Nie pozwalamy "odhaczyc" gdy sa paczki */
      toggle.checked = true;
      showError(packsCount === 1
        ? getMsg('use-remove-pack', 'Aby zrezygnowac z pakowania, usun paczke przyciskiem kosza.')
        : getMsg('use-remove-all', 'Aby zrezygnowac z pakowania, usun wszystkie paczki.')
      );
      return;
    }
    root.classList.toggle('is-open', toggle.checked);
    toggle.setAttribute('aria-expanded', toggle.checked ? 'true' : 'false');
    hideError();
  }

  /* --- LICZNIK ZNAKOW --- */
  function handleTextareaInput(textarea) {
    const root = getRoot();
    if (!root) return;
    const counter = root.querySelector('[data-sw-giftwrap-count]');
    if (counter) {
      counter.textContent = textarea.value.length;
    }
  }

  /* --- EVENT DELEGATION ---
     Jeden listener na document - laczy wszystkie kliki po data-attrs.
     Dziala nawet po podmianie innerHTML drawera. */

  document.addEventListener('click', function (e) {
    /* Dodaj paczke */
    const btnAdd = e.target.closest('[data-sw-giftwrap-add]');
    if (btnAdd) {
      e.preventDefault();
      if (btnAdd.disabled) return;
      handleAdd(btnAdd);
      return;
    }

    /* Usun pojedyncza paczke */
    const btnPackRemove = e.target.closest('[data-sw-giftwrap-pack-remove]');
    if (btnPackRemove) {
      e.preventDefault();
      if (btnPackRemove.disabled) return;
      handlePackRemove(btnPackRemove);
      return;
    }

    /* Usun wszystkie paczki */
    const btnRemoveAll = e.target.closest('[data-sw-giftwrap-remove-all]');
    if (btnRemoveAll) {
      e.preventDefault();
      if (btnRemoveAll.disabled) return;
      handleRemoveAll(btnRemoveAll);
      return;
    }
  });

  document.addEventListener('change', function (e) {
    const toggle = e.target.closest('[data-sw-giftwrap-toggle]');
    if (toggle) {
      handleToggleChange(toggle);
    }
  });

  document.addEventListener('input', function (e) {
    const textarea = e.target.closest('[data-sw-giftwrap-dedication]');
    if (textarea) {
      handleTextareaInput(textarea);
    }
  });

  console.log('[sw-giftwrap] JS gotowy (event delegation)');
})();